import React, { useState } from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { DateFormat, checkPermissions } from 'hooks';
import PageSpinner from 'components/PageSpinner';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { Link } from 'react-router-dom';
//import _ from "lodash";
import { Input, Button, Form, Row, Col } from 'reactstrap';
import PopupWindow from 'components/ModalPopup';

const CampaignList = (props) => {

    const [query, setQuery] = useState("");
    const [capnStatus, setCapnStatus] = useState("");
    const [statusPopup, setStatusPopup] = useState(false);
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });


    const [selectedCampaign, setSelectedCampaign] = React.useState({

        id: null,
        status: null

    });

    const [order, setOrder] = React.useState({

        order_by: `created_at`,
        direction: 'desc'

    });

    const fetchCampaigns = (filters) => {
        props.getCampaigns(filters);
    }

    React.useEffect(() => {
        let filters = {
            keyword: query,
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction,
            capnStatus: capnStatus
        };
        fetchCampaigns(filters)
    }, [pagination, order]);

    React.useEffect(() => {
        setStatusPopup(false)
        if (props.statusUpdated) {
            let filters = {
                keyword: query,
                page: pagination.page,
                page_limit: pagination.page_limit,
                order_by: order.order_by,
                direction: order.direction,
                capnStatus: capnStatus
            };
            fetchCampaigns(filters);
        }
    }, [props.statusUpdated]);

    const columns = () => {
        const cols = [
            { name: "campaign_name", label: "Campaign Name" },
            { name: "user_id", label: "user_id" },
            { name: "username", label: "Username" },
            { name: "target_gender", label: "Target Gender" },
            { name: "target_location", label: "Target Location" },
            { name: "target_age_minimum", label: "Min Age" },
            { name: "target_age_maximum", label: "Max Age" },
            { name: "status", label: "Status" },
            { name: "updated_at", label: "Last Updated" },
            { name: "id", label: "Action" }

        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'user_id' || column.name === 'target_location') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (tableMeta.columnData.name === 'created_at' || tableMeta.columnData.name === 'updated_at') ?
                            DateFormat(value, 'MM-DD-YYYY HH:mm:ss') :
                            (tableMeta.columnData.name === 'username') ?
                                (checkPermissions(props.loginData, 'user_profile')) ? <Link to={`/user-profile/${tableMeta.rowData[1]}`}>{value}</Link> : value
                                : (tableMeta.columnData.name === 'status') ? checkPermissions(props.loginData, 'campaign_status') ? <Button color="link" onClick={() => handleStatus(tableMeta.rowData[9], value)}>{value}</Button> : value
                                    : (tableMeta.columnData.label === 'Action') ?
                                        checkPermissions(props.loginData, 'campaign_details') ? <Link className={'view-profile-link'} to={`/campaign-details/${value}`}><Button color="primary" className="border-0" >View</Button></Link> : <Button color="primary" disabled={true} className="border-0 btn-disabled" >View</Button>
                                        : value;
                    }
                }
            }
        })
    }

    const handleStatus = (id, status) => {
        setSelectedCampaign({ id, status });
        setStatusPopup(true)

    }



    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };


    const handleChange = (event) => {

        setQuery(event.target.value);
        //debounce(event.target.value, pagination);
    };
    /*const debounce = useCallback(
        _.debounce((searchVal, pagination) => {
            let filters = { keyword: searchVal, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction }
            fetchCampaigns(filters);
        }, 1000),
        []
    );*/

    const handleSubmit = () => {
        props.changeStatus(selectedCampaign);
    }

    const campaignStatus = ['Approved', 'Completed', 'Draft', 'Paused', 'Pending'];
    const handleFilterChange = (e) =>{
        setCapnStatus(e.target.value);
    }
    
    const handleSearch =()=>{
        let filters = { capnStatus: capnStatus, keyword: query, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction }
        fetchCampaigns(filters);
    }
    return (
        <div>
            <PopupWindow hideButton={true} buttonStyle={{ marginTop: 10, width: '100%' }} handlePopup={(popup) => { setStatusPopup(popup) }} openWindow={statusPopup} title={'Change Status'} launchButtonText={'Change Status'} >
                <div>
                    <div style={{ display: 'flex' }}>
                        <Form>
                            <Input onChange={(e) => {
                                selectedCampaign.status = e.target.value;
                                setSelectedCampaign(selectedCampaign);
                            }} className="mb-2" type="select" defaultValue={(selectedCampaign && selectedCampaign.status) ? selectedCampaign.status : ''} style={{ width: 200, display: 'inline' }}>
                                <option value={0}>Select Group</option>
                                {campaignStatus.map((item) => (<option key={item} value={item}>{item}</option>))}
                            </Input>
                            <Button onClick={handleSubmit} style={{ padding: 10, marginLeft: 20, verticalAlign: 'top' }} color="primary" size="lg" className="border-0" >Change</Button>
                        </Form>

                    </div>
                </div>
            </PopupWindow>
            <Row>
                <Col lg={4} md={6} sm={6} xs={12}>
                    <Input
                        type="text"
                        name="query"
                        id="query"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={query}
                        placeholder={'Search by campaign name OR username'}
                        style={{ width: 346, marginBottom: 10 }}
                    />
                </Col>
                <Col lg={3} md={6} sm={6} xs={12}>
                    <Input name={'transaction_type'} onChange={handleFilterChange} className="mb-2"
                        type="select" defaultValue={''}
                        style={{ width: 250 }}>
                        <option value={0}>Transaction Type</option>
                        {campaignStatus.map((item) => (<option key={item} value={item}>{item}</option>))}
                    </Input>
                </Col>
                <Col lg={3} md={6} sm={6} xs={12}>
                <Button
                    color="primary"
                    style={{ padding: 'auto' }}
                    size="sm"
                    className="dashboard-search-btn"
                    onClick={handleSearch}
                    block >
                    Search
                </Button>
                </Col>
            </Row>

            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.campaignsList} columns={columns()} options={options} />
            }


        </div>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignsList: (state.campaign &&
        state.campaign.list &&
        state.campaign.list.data) ? state.campaign.list.data : [],
    totalCount: (state.campaign && state.campaign.list &&
        state.campaign.list.totalCampaigns) ? state.campaign.list.totalCampaigns : 0,
    statusUpdated: (state.campaign && state.campaign.statusUpdated) ? state.campaign.statusUpdated : undefined,
});
const mapDispatchToProps = (dispatch) => ({
    getCampaigns: (payload) => dispatch(CampaignAction.getCampaigns(payload)),
    changeStatus: (payload) => dispatch(CampaignAction.changeStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignList);
